import { router } from '../main';
var VueScrollTo = require('vue-scrollto');

export const getPagination = (pages: number, currentPage: number): Array<any> => {
    
    const currPage = currentPage + 1;
    let arr = [...Array(pages)].map((v, i) => i + 1)
    if (pages < 7) return arr
    else { 
        return arr.map((v ,i) => {
            if(i === 0 || (i === pages - 1)) {
                return v;
            }
            else if(v < (currPage + ((currPage <= 3) ? 3 : 2)) && v > (currPage - 3)) {
                return v
            }
            else if(v < currPage - 3 || v > currPage + ((currPage <= 3) ? 3 : 2)) {
                return null
            } else {
                return '...'
            }
            
        }).filter(f => f !== null)
    }
}

export const routerReplace = (queryObject: object) => {
    router.replace(queryObject)
        .catch(err => {
            if(err.name !== 'NavigationDuplicated') {
                console.error(err)
            }
        }) 
}

export const scroller = (element: HTMLElement, duration: number, options: object) => {
    
    return VueScrollTo.scrollTo(element, duration, options)
}